import { upperFirst } from 'lodash'

import { Currency } from '@sigmasms/shared-types'

import { components, proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy() ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options),
        {
          props: {
            value: this.proxy,
            items: [
              {
                component: components.select,
                props: {
                  items: Object.values(Currency).map(item => {
                    return {
                      value: item,
                      title: this.getTranslate(`${options.path}.${item}`)
                    }
                  }),
                  required: true,
                  clearable: false
                }
              }
            ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
